"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

var _TicketActions = _interopRequireDefault(require("./TicketActions"));

var _EditList = _interopRequireDefault(require("../Certificate/EditList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    padding: {
      padding: 24
    }
  };
});

var TicketInfo = function TicketInfo(_ref) {
  var ticket = _ref.ticket,
      user = _ref.user,
      actionProps = _ref.actionProps,
      openFabricate = _ref.openFabricate,
      setPdfOpen = _ref.setPdfOpen,
      labels = _ref.labels;
  var classes = useStyles();
  var history = ticket.history,
      changes = ticket.changes;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.statusChanges), /*#__PURE__*/_react["default"].createElement(_core.List, null, history.map(function (_ref2) {
    var author = _ref2.author,
        statusLabel = _ref2.statusLabel;
    return author && /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: author.person.avatar && author.person.avatar.src
      }),
      textLabel: author.person.fullName,
      text: statusLabel
    });
  })), /*#__PURE__*/_react["default"].createElement(_TicketActions["default"], _extends({
    user: user,
    ticket: ticket,
    labels: labels.actions
  }, actionProps)), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.edits.title), /*#__PURE__*/_react["default"].createElement(_EditList["default"], {
    edits: changes,
    openFabricate: openFabricate,
    setPdfOpen: setPdfOpen,
    labels: labels.edits
  }));
};

var _default = TicketInfo;
exports["default"] = _default;